import isEmpty from "lodash-es/isEmpty"
import isUndefined from "lodash-es/isUndefined"
import map from "lodash-es/map"

import { selfAssessmentBaseAdapter } from "@/3514/adapters"

import type {
    IPostSessionModuleReflectionDto as IModuleReflectionDto,
    IPostSessionModuleReflectionModel as IModuleReflectionModel,
    IPostSessionModuleReflectionQuestionsQueryDto as IModuleReflectionQuestionsQueryDto,
    IPostSessionModuleReflectionQuestionsQueryModel as IModuleReflectionQuestionsQueryModel,
    IPostSessionInitialDataDto,
    IPostSessionInitialDataModel,
    IPostSessionSelfAssessmentAnswerDataDto as ISelfAssessmentAnswerDataDto,
    IPostSessionSelfAssessmentAnswerDataModel as ISelfAssessmentAnswerDataModel,
    IPostSessionSelfAssessmentAnswerDto as ISelfAssessmentAnswerDto,
    IPostSessionSelfAssessmentAnswerModel as ISelfAssessmentAnswerModel
} from "./post-session.modal.api.types"

function _renderAnswers<
    TDto extends ISelfAssessmentAnswerDto | ISelfAssessmentAnswerDataDto,
    TModel extends ISelfAssessmentAnswerModel | ISelfAssessmentAnswerDataModel
>(dtos: TDto[]): TModel[] {
    return isEmpty(dtos)
        ? []
        : map<TDto, TModel>(
              dtos,
              ({
                  answer,
                  is_active: isActive,
                  option_uuid: optionUuid,
                  question,
                  question_uuid: questionUuid,
                  rank
              }: TDto): TModel =>
                  ({
                      answer,
                      isActive,
                      optionUuid,
                      question,
                      questionUuid,
                      rank
                  }) as TModel
          )
}

function moduleReflectionQuestionsAdapter(
    dto: IModuleReflectionQuestionsQueryDto
): IModuleReflectionQuestionsQueryModel {
    return isEmpty(dto)
        ? null
        : {
              moduleReflections: isEmpty(dto.module_reflection)
                  ? []
                  : map<IModuleReflectionDto, IModuleReflectionModel>(
                        dto.module_reflection,
                        ({
                            component_type: componentType,
                            content,
                            is_active: isActive,
                            order,
                            prompt,
                            question,
                            question_type: questionType,
                            uuid
                        }: IModuleReflectionDto): IModuleReflectionModel => ({
                            componentType,
                            content,
                            isActive,
                            order,
                            prompt,
                            question,
                            questionType,
                            uuid
                        })
                    ),
              selfAssessment: isEmpty(dto.self_assessment)
                  ? null
                  : {
                        answerData: _renderAnswers(dto.self_assessment.answer_data),
                        answerList: _renderAnswers(dto.self_assessment.answer_list),
                        ...selfAssessmentBaseAdapter(dto.self_assessment)
                    }
          }
}

function reflectionInitialDataAdapter(dto: IPostSessionInitialDataDto): IPostSessionInitialDataModel {
    return isEmpty(dto)
        ? null
        : {
              sessionId: dto.coaching_session,
              module: isUndefined(dto.module)
                  ? null
                  : {
                        rank: dto.rank,
                        id: dto.module,
                        title: { en: dto.module_title, es: dto.module_title, pt: dto.module_title }
                    }
          }
}

export default {
    moduleReflectionQuestions: moduleReflectionQuestionsAdapter,
    reflectionInitialData: reflectionInitialDataAdapter
}
